import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import api from 'utils/api';
import dayjs from 'dayjs';
import jalaliday from 'jalaliday';
import { useProviderStore } from 'Store/ProviderStore';
dayjs.extend(jalaliday);

const ClientManagement = (selectedProvider) => {
  console.log('selectedProvider in ClientManagement:', selectedProvider);
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filteredClients, setFilteredClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const provider = useProviderStore((state) => state.provider);

  const [serviceOptions, setServiceOptions] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    services: [],
    workSchedule: [],
    avatar: '',
  });

  // Load employees from backend
  useEffect(() => {
    console.log('start getting employees');
    fetchClients();
    getServices();
  }, [selectedProvider]);

  const getServices = async () => {
    try {
      const response = await api.get(`/providers/${provider._id}/services`);
      console.log('list of services', response.data);
      setServiceOptions(response.data);
      return response.data; // array of services
    } catch (error) {
      console.error('Error fetching services:', error);
      return []; // return empty array on error
    }
  };

  const fetchClients = async () => {
    try {
      //  setIsLoading(true);
      const { data } = await api.get(`/providers/${provider._id}/clients`);

      console.log('got clients', data);
      setFilteredClients(data);
    } catch (error) {
      console.error('Error fetching clients:', error);
    } finally {
      //setIsLoading(false);
    }
  };

  const workDayOptions = [
    { value: 'saturday', label: 'شنبه' },
    { value: 'sunday', label: 'یکشنبه' },
    { value: 'monday', label: 'دوشنبه' },
    { value: 'tuesday', label: 'سه‌شنبه' },
    { value: 'wednesday', label: 'چهارشنبه' },
    { value: 'thursday', label: 'پنج‌شنبه' },
    { value: 'friday', label: 'جمعه' },
  ];

  const handleFormSubmit = async (e) => {
    e?.preventDefault();

    const payload = {
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      services: formData.services,
      workSchedule: formData.workSchedule.filter(
        (d) => d.startTime && d.endTime // only send valid days
      ),
    };
    console.log('Submitting form with data:', payload);
    try {
      if (showAddModal) {
        // ✅ CREATE new employee
        await api.post(`/providers/${provider._id}/employees`, payload);
      } else if (showEditModal && selectedEmployee?._id) {
        // ✅ UPDATE existing employee
        await api.put(
          `/providers/${provider._id}/employees/${selectedEmployee._id}`,
          payload
        );
      }

      // ✅ Refresh list & close modals
      await fetchEmployees();
      setShowAddModal(false);
      setShowEditModal(false);
      setSelectedEmployee(null);
      toast.success('کارمند با موفقیت ذخیره شد!');
      toast.error('خطا در ذخیره اطلاعات');
    } catch (error) {
      console.error('Error saving employee:', error);
    }
  };

  const handleAddEmployee = () => {
    setFormData({
      name: '',
      phone: '',
      email: '',
      services: [],
      workDays: [],
      startTime: '09:00',
      endTime: '18:00',
    });
    setShowAddModal(true);
  };
  const normalizedServiceOptions = serviceOptions.map((s) => ({
    value: s._id,
    label: s.name,
  }));

  const handleEditClient = (client) => {
    setSelectedClient(client);

    setFormData({
      name: client?.name,
      phone: client?.phone,
      email: client?.email,
      services: client?.services?.map((service) =>
        typeof service === 'object' ? service._id : service
      ),
      workSchedule:
        client?.workSchedule?.length > 0
          ? client.workSchedule
          : [
              { day: 'شنبه', startTime: '', endTime: '' },
              { day: 'یکشنبه', startTime: '', endTime: '' },
              { day: 'دوشنبه', startTime: '', endTime: '' },
              { day: 'سه‌شنبه', startTime: '', endTime: '' },
              { day: 'چهارشنبه', startTime: '', endTime: '' },
              { day: 'پنج‌شنبه', startTime: '', endTime: '' },
              { day: 'جمعه', startTime: '', endTime: '' },
            ],
    });

    setShowEditModal(true);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'فعال':
        return 'text-success bg-success/10';
      case 'مرخصی':
        return 'text-warning bg-warning/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getUserTypeColor = (type) => {
    switch (type) {
      case 'regular':
        return 'text-blue-600 bg-blue-100';
      case 'vip':
        return 'text-purple-600 bg-gold-300';
      case 'vvip':
        return 'text-yellow-600 bg-yellow-100';

      case 'influencer':
        return 'text-pink-600 bg-pink-100';
      case 'staff':
        return 'text-green-600 bg-green-100';
      case 'partner':
        return 'text-indigo-600 bg-indigo-100';
      case 'other':
        return 'text-gray-600 bg-gray-100';
      case 'defaulter':
        return 'text-red-600 bg-red-100';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getUserType = (type) => {
    switch (type) {
      case 'regular':
        return 'عادی';
      case 'vip':
        return 'ویژه';
      case 'vvip':
        return 'بسیار ویژه';
      case 'influencer':
        return 'اینفلوئنسر';
      case 'staff':
        return 'کارمند';
      case 'partner':
        return 'همکار';
      case 'other':
        return 'سایر';
      case 'defaulter':
        return 'بدهکار';
      default:
        return 'ناشناخته';
    }
  };

  return (
    <div className="space-y-6">
      {/* Header and Search */}
      <div className="flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
        <div>
          <h2 className="text-xl font-semibold text-foreground">
            مدیریت مشتریان
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            مدیریت اطلاعات و برنامه کاری کارکنان خدمات دهنده
          </p>
        </div>
        {/* <Button
          variant="default"
          onClick={handleAddEmployee}
          iconName="Plus"
          iconPosition="right">
          افزودن مشتری جدید
        </Button> */}
      </div>
      {/* Search and Filters */}
      <div className="flex flex-col sm:flex-row gap-4">
        {/* <div className="flex-1">
          <Input
            type="search"
            placeholder="جستجو بر اساس نام، تلفن یا خدمات..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            className="w-full"
          />
        </div> */}
      </div>
      {/* Employee Table - Desktop */}
      <div className="hidden lg:block bg-card border border-border rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted/50 border-b border-border">
              <tr>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  مشتری
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  تاریخ ثبت نام
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  اطلاعات تماس
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  سطح مشتری
                </th>
                {/* <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  وضعیت اکانت
                </th> */}
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  مدیریت مشتری
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {filteredClients?.map((client) => (
                <tr
                  key={client?._id}
                  className="hover:bg-muted/30 transition-colors duration-150">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div>
                        <p className="text-sm font-medium text-foreground">
                          {client?.clinetName || 'بدون نام'}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div>
                        <p className="text-sm font-medium text-foreground">
                          {dayjs(client.DateOfRegister)
                            .locale('fa')
                            .calendar('jalali')
                            .format('D MMMM YYYY')}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="space-y-1">
                      <p className="text-sm text-foreground">
                        {client?.phoneNumber}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {client?.email}
                      </p>
                    </div>
                  </td>

                  <td className="px-6 py-4">
                    <span
                      className={`inline-block px-2 py-1 text-xs rounded-md ${getUserTypeColor(
                        client?.clientType
                      )}`}>
                      {getUserType(client?.clientType)}
                    </span>
                  </td>
                  {/* <td className="px-6 py-4">
                    <span
                      className={`inline-block px-2 py-1 text-xs rounded-md ${getStatusColor(
                        client?.status
                      )}`}>
                      {client?.status}
                    </span>
                  </td> */}
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-center gap-2">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleEditClient(client)}
                        iconName="Edit"
                        iconSize={16}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Employee Cards - Mobile */}
      {/* <div className="lg:hidden space-y-4">
        {filteredEmployees?.map((employee) => (
          <div
            key={employee?.id}
            className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-muted">
                  <img
                    src={employee?.avatar}
                    alt={employee?.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground">
                    {employee?.name}
                  </h3>
                  <p className="text-xs text-muted-foreground">
                    {employee?.phone}
                  </p>
                </div>
              </div>
              <span
                className={`inline-block px-2 py-1 text-xs rounded-md ${getStatusColor(
                  employee?.status
                )}`}>
                {employee?.status}
              </span>
            </div>

            <div className="space-y-2 mb-4">
              <div>
                <p className="text-xs text-muted-foreground mb-1">خدمات:</p>
                <div className="flex flex-wrap gap-1">
                  {employee?.services?.map((service, index) => (
                    <span
                      key={index}
                      className="inline-block px-2 py-1 text-xs bg-primary/10 text-primary rounded-md">
                      {typeof service === 'object'
                        ? service?.name
                        : normalizedServiceOptions.find(
                            (s) => s.value === service
                          )?.label || service}
                    </span>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">
                  ساعات کاری: {employee?.workTime}
                </p>
              </div>
            </div>

            <div className="flex gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleEditEmployee(employee)}
                iconName="Edit"
                iconPosition="right"
                className="flex-1">
                ویرایش
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleDeleteEmployee(employee)}
                iconName="Trash2"
                iconPosition="right"
                className="text-error border-error hover:bg-error/10">
                حذف
              </Button>
            </div>
          </div>
        ))}
      </div> */}
      {/* Add/Edit Employee Modal */}
      {(showAddModal || showEditModal) && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
          <div className="bg-popover border border-border rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto animate-scale-in">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-foreground">
                  {showAddModal ? 'افزودن مشتری جدید' : 'ویرایش اطلاعات مشتری'}
                </h3>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => {
                    setShowAddModal(false);
                    setShowEditModal(false);
                  }}
                  iconName="X"
                  iconSize={20}
                />
              </div>

              <form onSubmit={handleFormSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="نام و نام خانوادگی"
                    type="text"
                    placeholder="نام مشتری را وارد کنید"
                    value={formData?.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e?.target?.value })
                    }
                    required
                  />
                  <Input
                    label="شماره تلفن"
                    type="tel"
                    placeholder="09123456789"
                    value={formData?.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e?.target?.value })
                    }
                    required
                  />
                </div>

                <Input
                  label="آدرس ایمیل"
                  type="email"
                  placeholder=""
                  value={formData?.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e?.target?.value })
                  }
                />
                <Select
                  label="خدمات ارائه شده"
                  description="خدماتی که این کارمند ارائه می‌دهد"
                  options={normalizedServiceOptions} // ✅ Fixed
                  value={formData?.services} // ✅ Must be array of IDs only
                  onChange={(value) =>
                    setFormData({ ...formData, services: value })
                  }
                  multiple
                  searchable
                  required
                />
                <Select
                  label="روزهای کاری"
                  description="روزهایی که این کارمند در دسترس است"
                  options={workDayOptions}
                  value={(formData?.workSchedule || []).map((d) => d.day)}
                  onChange={(selectedDays) => {
                    const updatedSchedule = selectedDays.map((day) => {
                      const existing = (formData.workSchedule || []).find(
                        (d) => d.day === day
                      );
                      return existing || { day, startTime: '', endTime: '' };
                    });
                    setFormData({ ...formData, workSchedule: updatedSchedule });
                  }}
                  multiple
                  required
                />

                <div className="grid grid-cols-2 gap-4">
                  <Input
                    label="ساعت شروع کار"
                    type="time"
                    value={formData?.startTime}
                    onChange={(e) =>
                      setFormData({ ...formData, startTime: e?.target?.value })
                    }
                    required
                  />
                  <Input
                    label="ساعت پایان کار"
                    type="time"
                    value={formData?.endTime}
                    onChange={(e) =>
                      setFormData({ ...formData, endTime: e?.target?.value })
                    }
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2 text-foreground">
                    برنامه کاری هفتگی
                  </label>
                  <div className="space-y-3">
                    {(formData?.workSchedule || []).map((day, index) => (
                      <div
                        key={day.day}
                        className="grid grid-cols-3 gap-3 items-center border-b border-border pb-2">
                        <span className="text-sm">{day.day}</span>
                        <Input
                          type="time"
                          value={day.startTime}
                          onChange={(e) => {
                            const updated = [...(formData.workSchedule || [])];
                            updated[index].startTime = e.target.value;
                            setFormData({ ...formData, workSchedule: updated });
                          }}
                        />
                        <Input
                          type="time"
                          value={day.endTime}
                          onChange={(e) => {
                            const updated = [...(formData.workSchedule || [])];
                            updated[index].endTime = e.target.value;
                            setFormData({ ...formData, workSchedule: updated });
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex gap-3 pt-4">
                  <Button type="submit" variant="default" className="flex-1">
                    {showAddModal ? 'افزودن کارمند' : 'ذخیره تغییرات'}
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => {
                      setShowAddModal(false);
                      setShowEditModal(false);
                    }}
                    className="flex-1">
                    انصراف
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      {showDeleteModal && selectedClient && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
          <div className="bg-popover border border-border rounded-lg w-full max-w-md animate-scale-in">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-error/10 rounded-full flex items-center justify-center">
                  <Icon name="AlertTriangle" size={20} className="text-error" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-foreground">
                    حذف کارمند
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    این عمل قابل بازگشت نیست
                  </p>
                </div>
              </div>

              <p className="text-sm text-foreground mb-6">
                آیا از حذف کارمند <strong>{selectedClient?.name}</strong>{' '}
                اطمینان دارید؟ تمام اطلاعات مربوط به این کارمند حذف خواهد شد.
              </p>

              <div className="flex gap-3">
                <Button
                  variant="destructive"
                  onClick={() => {
                    console.log('Delete client:', selectedClient?.id);
                    setShowDeleteModal(false);
                    setSelectedClient(null);
                  }}
                  className="flex-1">
                  حذف مشتری
                </Button>
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setSelectedClient(null);
                  }}
                  className="flex-1">
                  انصراف
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientManagement;
